import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import { isExpired, decodeToken } from "react-jwt";
import { FormGroup, Label, Input, Form, Row, Col } from 'reactstrap';
import {
    Card, CardImg, CardText, CardBody,
    CardTitle, CardSubtitle, Button
} from 'reactstrap';
import empleadoimg from '../assets/img/empleado.png';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { unregister } from "../Interceptor.js";
import { useEffect } from 'react';
import Spinner from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';

var currentDate = moment(new Date());
var futureMonth = moment(currentDate).add(1, 'M');
var futureMonthEnd = moment(futureMonth).endOf('month');
localStorage.setItem('conref', true);

if (currentDate.date() != futureMonth.date() && futureMonth.isSame(futureMonthEnd.format('YYYY-MM-DD'))) {
    futureMonth = futureMonth.add(1, 'd');
}

function setDates() {
    localStorage.setItem('fechaExpedicion', moment(currentDate).format('YYYY-MM-DDTHH:mm:ss'));
    console.log(localStorage.getItem('fechaExpedicion'));
    localStorage.setItem('fechaVencimiento', moment(futureMonthEnd).format('YYYY-MM-DDTHH:mm:ss'));
    console.log(localStorage.getItem('fechaVencimiento'));
}

setDates();

localStorage.setItem('tipoComprobante', 1);
localStorage.setItem('tipoFactura', 1);
localStorage.setItem('numeracionAuto', true);
localStorage.setItem('prefijoFacNumeracion', "");
localStorage.setItem('numeroFacNumeracion', 0);


var cont = 0;
var dataTipos = [{}];
var dataTiposFac = [{ "Codigo": 4, "Descripcion": "Documento Genérico" }];
var dataTiposCorr = [{}];
var dataEmpleados = [{}];
var idempleado = localStorage.getItem("idEmpleado") ?? 0;


export default function Start() {

    useEffect(() => {
        selectDataLoad();
        localStorage.setItem('observaciones', " ");
        login();
        cont = cont + 1;
        //console.log(parseInt(localStorage.getItem("idEmpleado")));
        //    empleado(localStorage.getItem("idEmpleado"));
        //    setIdEmpleado(localStorage.getItem("idEmpleado"));
    }, []);

    const [loading, setLoading] = React.useState(false);

    const [idEmpleado, setIdEmpleado] = React.useState(parseInt(idempleado));

    const selectDataLoad = () => {

        /*var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        console.log(isMyTokenExpired);
        if (isMyTokenExpired) {
            window.location = "/"
        }*/

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };



        fetch("./api/Auxiliar/ListaTiposComprobante?IncluirSoloPrincipales=true", requestOptions)
            .then(response => response.json())
            .then(result => {

                dataTipos = result.basePresentationList;
                localStorage.setItem('listaTiposComprobantes', dataTipos);
                console.log(dataTipos);
                setData(dataTipos);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }

    const [nofac, setnoFac] = React.useState(true);

    const ListaConceptoCorreccionNotasDian = (value) => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var tiponota = value;
        var url = "./api/Auxiliar/ListaConceptoCorreccionNotasDian?TipoNota=" + tiponota;
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {

                dataTiposCorr = result.basePresentationList;
                //localStorage.setItem('listaTiposComprobantes', dataTipos);
                console.log(dataTiposCorr);
                setDataCorrec(dataTiposCorr);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }

    const login = () => {

        setLoading(true);

        var myHeaders = new Headers();
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        const apiUrl = './api/Empleado/Empleados';
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(

                data => {
                    var emp = [];
                    emp = data.basePresentationList;
                    console.log(data);
                    dataEmpleados = data.basePresentationList;
                    setEmpleadosDatos(dataEmpleados);
                    localStorage.setItem('numeracionAuto', true);
                    localStorage.setItem("idEmpleado", emp[0].CodigoCliente);



                        setLoading(false); //After 1 second, set render to true


                    
                }

            )
            .catch(error => {
                console.log('error', error);

            }
            )
    }

    const handleEmpleado = (e) => {
        const selectedIndex = e.target.options.selectedIndex;
        console.log(event.target.options[selectedIndex].getAttribute('data-key'));
        empleado(event.target.options[selectedIndex].getAttribute('data-key'));
        setIdEmpleado(event.target.options[selectedIndex].getAttribute('data-key'));
        localStorage.setItem("idEmpleado", event.target.options[selectedIndex].getAttribute('data-key'));
        idempleado = event.target.options[selectedIndex].getAttribute('data-key');
        console.log(localStorage.getItem("idEmpleado"));
    }

    const [showEmpleado, setshowEmpleado] = React.useState(true);

    const [Nombre, setNombre] = React.useState(true);
    const [Nit, setNit] = React.useState(true);
    const [Correo, setCorreo] = React.useState(true);
    const [IDInterno, setIDInterno] = React.useState(true);

    const empleado = (id) => {

        setLoading(true);
        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

       

        const apiUrl = "./api/Empleado/TraerEmpleado?iIdEmpleado=" + id;
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(

                data => {
                    var emp = data.basePresentation;
                    console.log(data);
                    setNombre(emp.Nombre);
                    setNit(emp.Nit);
                    setCorreo(emp.Correo);
                    setIDInterno(emp.IDInterno);
                    setshowEmpleado(false);
                    setLoading(false);

                    localStorage.setItem("idEmpleado", id);
                }

            )
            .catch(error => {
                console.log('error', error);

            }
            )
    }

    if (cont < 2) {
        
    }

    const [empleadosDatos, setEmpleadosDatos] = React.useState(dataEmpleados);

    

    const [errorShow, setErrorShow] = React.useState(" ");

    const [dataTiposComprobante, setData] = React.useState(dataTipos);
    const [dataTiposFactura, setDataTipo] = React.useState(dataTiposFac);
    const [dataTiposCorreccion, setDataCorrec] = React.useState(dataTiposCorr);

    //set dates
    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const [selectedExpDate, setSelectedExpDate] = React.useState(new Date(futureMonth));
    const handleDateChange = (date) => {
        setSelectedDate(date);

    };
    const handleExpDateChange = (date) => {
        setSelectedExpDate(date);
        var date = new Date(date);

        localStorage.setItem('fechaVencimiento', moment(date).format('YYYY-MM-DDTHH:mm:ss'));
        console.log(localStorage.getItem('fechaVencimiento'));


    };

    //handle Tipo Comprobante
    const handleTipoComprobante = (selectedOption) => {

        localStorage.setItem('tipoComprobante', selectedOption.target.value)
        var value = selectedOption.target.value;
        if (value == 2) {
            ListaConceptoCorreccionNotasDian(value);
            var JSON = [
                {
                    "Codigo": 20, "Descripcion": "Nota Crédito con Referencia"
                },
                {
                    "Codigo": 22, "Descripcion": "Nota Crédito sin Referencia"
                }];
            setDataTipo(JSON);
            setnoFac(false);
        } else if (value == 3) {
            //cargueTiposComprobante
            ListaConceptoCorreccionNotasDian(value);
            var JSON = [
                {
                    "Codigo": 30, "Descripcion": "Nota Débito con Referencia"
                },
                {
                    "Codigo": 32, "Descripcion": "Nota Débito sin Referencia"
                }];
            setDataTipo(JSON);
            setnoFac(false);
        } else if (value == 1) {
            var JSON = [
                {
                    "Codigo": 4, "Descripcion": "Documento Genérico"
                }];
            setDataTipo(JSON);
            setnoFac(true);
        }
        console.log(localStorage.getItem('tipoComprobante'));
    };

    //handle Tipo Factura
    const handleTipoFactura = (selectedOption) => {

        localStorage.setItem('tipoFactura', selectedOption.target.value);

        if (selectedOption.target.value == 20 || selectedOption.target.value == 30) {
            localStorage.setItem('conref', false);
        } else {
            localStorage.setItem('conref', true);
        }

        console.log(localStorage.getItem('tipoFactura'));

    };

    //handle Tipo Correcion
    const handleTipoCorrecionD = (selectedOption) => {
        localStorage.setItem('tipoCorreccion', selectedOption.target.value)

        console.log(localStorage.getItem('tipoCorreccion'));

    };

    const [numeracionAuto, setNumeracionAuto] = React.useState(localStorage.getItem('numeracionAuto') == "true" ? true : false);
    const [prefijoFac, setPrefijoFac] = React.useState(localStorage.getItem('prefijoFacNumeracion') ?? "");
    const [numeroFac, setNumeroFac] = React.useState(localStorage.getItem('numeroFacNumeracion') ?? 0);

    const handleChangeChecked = (event) => {

        setNumeracionAuto(event.target.checked);
        if (event.target.checked === true) {
            setPrefijoFac("");
            setNumeroFac(0);
        }
        localStorage.setItem('numeracionAuto', event.target.checked)
    };

    const handleChangePrefijo = (event) => {
        console.log(event.target.value);
        setPrefijoFac(event.target.value);
        localStorage.setItem('prefijoFacNumeracion', event.target.value)
    };
    const handleChangeNumero = (event) => {
        console.log(event.target.value);
        setNumeroFac(event.target.value);
        localStorage.setItem('numeroFacNumeracion', event.target.value)
    };

    return (
        <React.Fragment>


            <Dialog open={loading} >
                <div style={{ textAlign: "center", margin: "15px" }}>
                    {loading && <Spinner color="secondary" />}
                    <h3 style={{ fontSize: '15px', fontFamily: 'Hammersmith One' }}>Cargando...</h3>
                </div>
            </Dialog>

                    <h5 style={{ textAlign: "center", fontSize: "20px" }}>Comprobante de Nómina</h5>
                    <Form>
                        <Row>
                            <Col md="2">
                    </Col>
                    <Col md="1" style={{ borderRight: "6px solid #1d8cf8", height: "70px"}}>
                    </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="exampleEmail" style={{ fontSize: "12px" }}>Eliga un Empleado</Label>

                            <Input type="select" onChange={handleEmpleado} defaultValue={idEmpleado} name="select" id="exampleSelect" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                {empleadosDatos.map((tipo, index) => <option key={tipo.IdEmpleado} data-key={tipo.IdEmpleado}>{tipo.PrimerNombre + " " + tipo.PrimerApellido + " " + tipo.SegundoApellido + " - " + tipo.CodigoCliente}</option>)}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                            </Col>
                        </Row>
            </Form >

            {/*<hr
                style={{
                    color: "#adadad",
                    backgroundColor: "#adadad",
                    height: 1
                }}
            />*/}
            <Row>
            <Col md="3">

                </Col>
                <Col md="6">
                    <Card style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)" }} hidden={showEmpleado}>
                <Row style={{margin: "20px"}}>
                    
                            <Col md="5">
                                <CardImg width="100%" src={empleadoimg} style={{ marginTop: "5px" }} alt="Card image cap" />
                    </Col>
                    <Col md="7">
                    <CardBody>
                                    <CardTitle tag="h5">{Nombre}</CardTitle>
                                    <CardSubtitle tag="h6" className="mb-2 text-muted">{"Código Empleado: " + Nit}</CardSubtitle>
                                    <CardText>{Correo}</CardText>
                        </CardBody>
                    </Col>
                   
                </Row>
                    </Card>
                </Col>
            <Col md="3">

            </Col>
           </Row>
                </React.Fragment>
    );
}